import type { ReactNode } from 'react';

export interface SectionHeadingProps {
  kicker?: ReactNode;
  title: ReactNode;
  action?: ReactNode;
  level?: 1 | 2 | 3;
}

export function SectionHeading({
  kicker,
  title,
  action,
  level = 2,
}: SectionHeadingProps) {
  const fontSize =
    level === 1 ? 'var(--apm-text-3xl)' : 'var(--apm-text-2xl)';
  const heading = (
    <span
      style={{
        margin: 0,
        fontFamily: 'var(--apm-font-display)',
        fontWeight: 400,
        fontSize,
        letterSpacing: '-0.01em',
        lineHeight: 1.1,
        color: 'var(--apm-ink)',
      }}
    >
      {title}
    </span>
  );
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 16,
        marginBottom: 20,
      }}
    >
      <div>
        {kicker && (
          <div
            style={{
              fontSize: 11,
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              color: 'var(--apm-muted)',
              marginBottom: 8,
              fontWeight: 500,
            }}
          >
            {kicker}
          </div>
        )}
        {level === 1 ? <h1 style={{ margin: 0 }}>{heading}</h1> : <h2 style={{ margin: 0 }}>{heading}</h2>}
      </div>
      {action}
    </div>
  );
}
